import React, { FC } from 'react';
import { ListActionTarget } from '../../../models/ListActionTarget';
import { targetToIconCode } from '../utils/utils-target-to-icon-code';
import { LoadIndicator } from '../common/LoadIndicator';
import { getPriceTierLabel, PriceTier } from '../../../models/PriceTier';
import { useTranslation } from 'react-i18next';
import FormatCurrency from '../utils/formatCurrency';

type AddButtonProps = {
    readonly priceTier: PriceTier;
    readonly target: ListActionTarget;
    readonly onClick: () => void;
    readonly isLoading: boolean;
    readonly total?: number;
    readonly currency?: string;
};
export const AddButton: FC<AddButtonProps> = ({ priceTier, target, onClick, isLoading, total, currency }) => {
    const { t } = useTranslation();
    return (
        <div className="available-prices-selector" data-numoptions="1" onClick={onClick}>
            <div className="button-group button-group--lg">
                <button className="group-button group-button--clickable">
                    <span className="group-button-label">
                        <i className="material-icons">{targetToIconCode(target)}</i>
                        {getPriceTierLabel(priceTier, t)}
                    </span>
                    <span className="group-button-sublabel">
                        {isLoading ? (
                            <LoadIndicator />
                        ) : (
                            t('numberFormat.numberWithCurrencySymbol', {
                                val: FormatCurrency.convertIntegerToCurrencyFormat(total),
                                currencySymbol: FormatCurrency.mapCurrencyToSymbol(currency)
                            })
                        )}
                    </span>
                </button>
            </div>
            <div className="selected-flags">
                <div className="select">{t('select')}</div>
            </div>
        </div>
    );
};
